// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3L3lU","upload":"Small_upload__7w4QF","imageWrap":"Small_imageWrap__3_5OP","removeBtn":"Small_removeBtn__3_IZ_"};